import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { loginAuth } from "../redux/actions/auth.actions";
import { Button, Input } from "antd";
import "./Login-styles.scss";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../redux/store/hooks";
import {
  getAuthErrorMsg,
  getAuthIsLoading,
  getAuthIsLoggedIn,
} from "../redux/selectors";
import { LoadingOutlined } from "@ant-design/icons";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector(getAuthIsLoggedIn);
  const isLoading = useSelector(getAuthIsLoading);
  const errorMsg = useSelector(getAuthErrorMsg);
  const dispatch = useAppDispatch();
  const [state, setState] = useState({
    login: "megafon@test.ru",
    password: "Asdf12321-",
  });

  useEffect(() => {
    handleSubmit();
    if (isLoggedIn) {
      navigate("/thread");
    } else navigate("/");
  }, [isLoggedIn]);

  const handleSubmit = (event?: React.FormEvent<HTMLFormElement>): void => {
    event?.preventDefault();

    if (isLoading) {
      return;
    }

    dispatch(
      loginAuth({
        login: state.login,
        password: state.password,
      })
    );
  };

  const handleInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <div className="">
      <div className="">
        {isLoading && (
          <div className="feed-posts-loader" style={{ height: "300px" }}>
            <LoadingOutlined />
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
